import BackendLinkModelI from '@/components/interfaces/IBackendLinkModel';

export default class LinkModel {
  url: string;

  text: string;

  abstract: string;

  cssClass: string;

  isActive: boolean;

  isOpen: boolean;

  target: string;

  editorField: string;

  constructor(backendLinkModel: BackendLinkModelI) {
    this.url = backendLinkModel.Url || '';
    this.text = backendLinkModel.Text || '';
    this.abstract = backendLinkModel.Abstract || '';
    this.cssClass = backendLinkModel.CssClass || '';
    this.isActive = backendLinkModel.IsActive || false;
    this.isOpen = backendLinkModel.IsOpen || false;
    this.target = backendLinkModel.Target || '';
    this.editorField = backendLinkModel.EditorField || '';
  }
}
